<div class = "ui-error-container">
    <i class = "ui-icon ui-icon-activated" [ngClass] = "{
        'uii-ghost': !isForbidden,
        'uii-police': isForbidden
    }" ></i>
    <div class = "ui-error-message-bold">
        {{ errorMessageBold }}
    </div>
    <div class = "ui-error-message">
        {{ errorMessage }}
    </div>
</div>
